<template>
    <div class="col-sm-12 editor-form" @click.stop="">
        <div class="no-margin">
            <span class="hint-text pl-1 pb-1">{{ $t('contracts.imported_contract_data_fetch_editor_decription')}}</span>
            <span class="item-detail-title pl-1 pt-1">{{ $t('contracts.basic_info') }}</span>
            <div v-if="importedContractData.name">
                <div class="row">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('contracts.name') }}</span>
                        <input
                            id="name"
                            :value="importedContractData.name"
                            type="text"
                            class="form-control form-control-sm"
                            readonly
                        />
                    </div>
                    <div class="col-sm-6 text-end">
                        <span class="span-title pb-1">{{ $t('common.update') }}</span>
                        <div class="form-check form-switch d-flex justify-content-end">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                v-model="nameSelected"
                                id="nameSelectedSwitch"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="importedContractData.start_date || importedContractData.end_date">
                <div class="row">
                    <div class="col-sm-5">
                        <span class="span-title">{{ $t('trip_list.start_time') }}</span>
                        <input
                            id="startDate"
                            :value="importedContractData.start_date"
                            type="text"
                            class="form-control form-control-sm"
                            readonly
                        />
                    </div>
                    <div class="col-sm-5">
                        <span class="span-title">{{ $t('trip_list.end_time') }}</span>
                        <input
                            id="endDate"
                            :value="importedContractData.end_date"
                            type="text"
                            class="form-control form-control-sm"
                            readonly
                        />
                    </div>
                    <div class="col-sm-2 text-end">
                        <span class="span-title pb-1">{{ $t('common.update') }}</span>
                        <div class="form-check form-switch d-flex justify-content-end">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                v-model="scheduleSelected"
                                id="scheduleSelectedSwitch"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <hr class="divider"/>
            <span class="item-detail-title pl-1 pt-1">{{ $t('menu.task_types') }}</span>
            <span class="hint-text pl-1 pb-2">{{ $t('contracts.imported_contract_missing_task_types')}}</span>
            <div v-if="importedContractData.task_types">
                <div v-for="option in importedContractData.task_types" :key="option.id" class="form-check grid-item">
                    <input
                        type="checkbox"
                        class="form-check-input form-check-input-sm"
                        :value="option.id"
                        v-model="selectedTaskTypes"
                        :id="'taskType' + option.id"
                    />
                    <label class="form-check-label ms-2" :for="'taskType' + option.id">
                        {{ option.name }}
                    </label>
                </div>
            </div>
            <div v-if="importedContractData.task_types" class="nopads pb-2">
                <div class="col-12 text-end">
                    <button class="btn btn-outline-secondary btn-sm form-button" :disabled="selectedTaskTypes.length < 1" @click.stop="clearTaskTypeSelection">
                        {{ $t('areas.deselect_all')}}
                    </button>
                    <button class="btn btn-outline-primary btn-sm form-button" :disabled="selectedTaskTypes.length === importedContractData.task_types.length" @click.stop="selectAllTaskTypes">
                        {{ $t('areas.select_all')}}
                    </button>
                </div>
            </div>
            <hr class="divider"/>
            <span class="item-detail-title pl-1 pt-1">{{ $t('menu.orders') }}</span>
            <div v-if="importedContractData.orders">
                <span class="hint-text pb-2">{{ $t('contracts.open_orders_from_imported_contract_data') }}</span>
                <div v-for="option in orderOptions" :key="option.value" class="form-check grid-item">
                    <input
                        type="checkbox"
                        class="form-check-input form-check-input-sm"
                        :value="option.value"
                        v-model="selectedOrders"
                        :id="'orderOption' + option.value"
                        :disabled="!isTaskTypeSelected(option.value)"
                    />
                    <label class="form-check-label" :for="'orderOption' + option.value">
                        {{ option.text }}
                    </label>
                </div>
            </div>
            <div v-if="orderOptions && orderOptions.length > 0" class="nopads pb-2">
                <div class="col-12 text-end">
                    <button class="btn btn-outline-secondary btn-sm form-button" :disabled="selectedOrders.length < 1" @click.stop="clearOrderSelection">
                        {{ $t('areas.deselect_all')}}
                    </button>
                    <button class="btn btn-outline-primary btn-sm form-button" :disabled="selectedTaskTypes.length !== importedContractData.task_types.length && selectedOrders.length !== orderOptions.length" @click.stop="selectAllOrders">
                        {{ $t('areas.select_all')}}
                    </button>
                </div>
            </div>

            <div v-if="!importedContractData || importedContractData.length === 0">
                    <em>{{ $t('contracts.imported_contract_data_not_found') }}</em>
            </div>
            <hr class="divider"/>
            <div class="col-sm-12 text-end my-2">
                <button class="btn btn-secondary form-button" @click.stop="$emit('closeModal')">
                    {{ $t('common.cancel') }}
                </button>
                <button type="submit" class="btn btn-success form-button" :disabled="!selectionValidated()" @click.stop="setImportedContractData">
                    {{ $t('contracts.save_data_to_contract') }}
                </button>
            </div>
        </div>

        <!-- Price list addition -->
        <base-modal v-if="pricelistModal" :title="$t('pricelist.add')" hide-header-close hide-footer size="lg" prevent-close>
            <price-list-editor
                :price-list="newList"
                :hideTitle="true"
                @close="pricelistModal = false"
                @closeAndUpdate="priceListAdded"/>
        </base-modal>
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {timeUtils} from '@/components/mixins/TimeUtils'
import {priceHelper} from "@/components/mixins/PricingMixin";
import PriceListEditor from "@/components/pricingmodels/pricelists/PriceListEditor";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: 'contract-data-importer',
    components: {BaseModal, PriceListEditor},
    mixins: [restApi, timeUtils, priceHelper],
    props: {
        contractObject: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: 0,
            contract: null,
            importedContractData: [],
            selectedOrders: [],
            pricelistModal: false,
            priceLists: [],
            newList: null,
            nameSelected: false,
            scheduleSelected: false,
            selectedTaskTypes: [],
            orderOptions: []
        }
    },
    watch: {
        selectedTaskTypes: function (newVal) {
            // Filter out any IDs in selectedOrders that are not present in selectedTaskTypes
            this.selectedOrders = this.selectedOrders.filter(orderId => newVal.includes(orderId));
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        this.fetchImportedContractData()
        this.fetchPriceLists()
        this.newList = this.newPriceList()
    },

    methods: {
        selectAllTaskTypes() {
            this.selectedTaskTypes = this.importedContractData.task_types.map(item => item.id)
        },
        selectAllOrders() {
            this.selectedOrders = this.orderOptions.map(item => item.value)
        },
        clearTaskTypeSelection() {
            this.allTaskTypes = false
            this.selectedTaskTypes = []
        },
        clearOrderSelection() {
            this.allOrders = false
            this.selectedOrders = []
        },
        fetchPriceLists: function () {
            this.loading++
            this.restFetch(this.priceListUrl,this.handlePriceListResponse)
        },
        handlePriceListResponse: function (response) {
            this.loading--
            this.priceLists = response.data
        },
        priceListAdded: function (newPriceList) {
            this.priceList = newPriceList.id
            this.fetchPriceLists()
            this.showPriceListEditor = false
            this.newList = this.newPriceList()
            this.pricelistModal = false
        },
        showPriceListEditor: function () {
            this.pricelistModal = true
        },
        selectionValidated() {
            return this.scheduleSelected || this.nameSelected || this.selectedTaskTypes.length > 0
        },
        isTaskTypeSelected: function (id) {
            return this.selectedTaskTypes.find(item => item === id) !== undefined
        },
        fetchImportedContractData() {
            this.loading++
            this.restFetchParams(this.contractImportUrl, {contract: this.contractObject.id, contractNumber: this.contractObject.contract_number}, this.handleResponse, this.fail)
        },
        handleResponse(response) {
            this.loading--
            if(response.data) {
                if(response.data.orders && response.data.orders.length > 0) {
                    response.data.orders.map(order => {
                        if(order.hasOwnProperty('price_list')) {
                            order.price_list = null
                        }
                    })
                }
                this.importedContractData = response.data
                this.initOrderOptions()
            }
        },

        initOrderOptions() {
            this.orderOptions = []
            if(this.importedContractData.orders) {
                this.importedContractData.orders.forEach(order => this.orderOptions.push( {
                    "text": order.contract_task_type.task_type.name + ' (' + order.unit_price +' '+import.meta.env.VITE_APP_CURRENCY+')',
                    "value": order.contract_task_type.task_type.id
                }))
            }
        },

        setImportedContractData() {
            this.loading++
            let json = this.setValues()
            this.restUpdate(this.contractImportUrl, json , this.handleSetImportedContractData, this.setImportedContractDataFail)
        },
        handleSetImportedContractData() {
            this.loading--
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.$emit('dataUpdated')
        },
        setValues() {
            let contractChanges = {}
            if(this.importedContractData.name && this.nameSelected) {
                contractChanges.name = this.importedContractData.name
            }
            if(this.importedContractData.start_date && this.scheduleSelected) {
                contractChanges.start_date = this.importedContractData.start_date
            }
            if(this.importedContractData.end_date && this.scheduleSelected) {
                contractChanges.end_date = this.importedContractData.end_date
            }
            if(this.selectedTaskTypes.length > 0) {
                contractChanges.task_types = this.selectedTaskTypes
            }
            if(this.importedContractData.contract_number) {
                contractChanges.contract_number = this.importedContractData.contract_number
            }
            if(this.selectedOrders && this.selectedOrders.length > 0) {
                contractChanges.orders = this.importedContractData.orders
                    .filter(order => this.selectedOrders.includes(order.contract_task_type.task_type.id));
            }
            return {
                contract: this.contractObject.id,
                contract_changes: contractChanges
            }
        },
        setImportedContractDataFail() {
            this.loading--
            this.showAlert(this.$t('contracts.imported_contract_data_update_failed'))
        },
        fail: function () {
            this.loading--
            this.showAlert(this.$t('contracts.imported_contract_data_fetching_failed'))
        },
    }
}
</script>

<style scoped>
.checkbox-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4 equal columns */
    gap: 10px; /* Adjust spacing between checkboxes */
}

.grid-item {
    display: flex;
    align-items: center;
    width: 100%; /* Ensures full width within grid cell */
}
</style>
